'use strict';

angular.module('ecrd')
    .component('fieldNotesInfo', {
        templateUrl: 'modules/ecrd/components/field/queries/field-info/content.html',
        controller: 'EntityFieldNotesInfoController',
        bindings: {
            fieldId: '@fieldId',
            onToggle: '&onToggle',
        },
    });
